import type { ReactNode } from 'react';

import './SetupSlot.scss';

export interface SetupSlotProps {
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  className?: string;
}

const SetupSlot = ({ icon, title, description, children, className }: SetupSlotProps) => (
  <div className={['setup-slot', className].filter(Boolean).join(' ')}>
    {icon && <span className="setup-slot__icon">{icon}</span>}
    <div className="setup-slot__content">
      {title && <span className="setup-slot__title">{title}</span>}
      {description && <span className="setup-slot__description">{description}</span>}
    </div>
    {children && <div className="setup-slot__actions">{children}</div>}
  </div>
);

export default SetupSlot;
